import { icons as appIcons } from "@/model/solution/apps";
import { iconTask, iconDashboard } from "@/design/icon/iconConst";

/**
 * Employee Access titles
 * @type {Readonly<{Tasks: string, TimeOff: string, Dashboard: string, Time: string, Requests: string, Profile: string}>}
 */
const titles = Object.freeze({
  Dashboard: "Dashboard",
  Time: "My Time",
  TimeOff: "My Time Off",
  // TeamTime: "Team Time",
  // Pay: "My Pay",
  Tasks: "My Tasks",
  Profile: "My Profile",
  Requests: "My Requests"
  // Benefits: "My Benefits",
  // Career: "My Career",
  // BrowseJobs: "Browse jobs",
  // UserManagement: "User Management"
  // Roles: "Roles",
  // RolesAssociation: "Roles Association"
});

/**
 * Employee Access names
 * @type {Readonly<{Tasks: string, TimeOff: string, Dashboard: string, Time: string, Requests: string, Profile: string}>}
 */
const names = Object.freeze({
  Dashboard: "Dashboard",
  Time: "Time",
  TimeOff: "TimeOff",
  // TeamTime: "TeamTime",
  // Pay: "Pay",
  Tasks: "Tasks",
  Profile: "Profile",
  Requests: "Requests"
  // Benefits: "Benefits",
  // Career: "Career",
  // BrowseJobs: "BrowseJobs",
  // UserManagement: "UserManagement"
  // Roles: "Roles",
  // RolesAssociation: "RolesAssociation"
});

/**
 * Employee Access icons
 * @type {Readonly<{BrowseJobs: string, Account: string, Tasks: string, TimeOff: string, Dashboard: string, Pay: string, Time: string, Benefits: string, Profile: string, Career: string}>}
 */
const icons = Object.freeze({
  Dashboard: iconDashboard,
  Requests: "mdi-form-select",
  Account: "mdi-card-account-details",
  Time: "mdi-account-clock-outline",
  TimeOff: "mdi-calendar-clock ",
  TeamTime: "mdi-account-supervisor-circle-outline",
  Pay: "mdi-cash-multiple",
  Tasks: iconTask,
  Profile: "mdi-card-account-details-outline",
  Benefits: "mdi-account-heart-outline ",
  Career: "mdi-badge-account-outline ",
  BrowseJobs: "mdi-account-network-outline ",
  UserManagement: "mdi-badge-account-outline"
  // Roles: "mdi-account-lock-outline",
  // RolesAssociation: "mdi-account-lock-outline"
});

/**
 * Employee Access routes
 * @type {Readonly<{Tasks: string, TimeOff: string, Dashboard: string, NotImplemented: string, Time: string, Requests: string, Profile: string}>}
 */
const routes = Object.freeze({
  Dashboard: "Dashboard",
  Time: "Time",
  TimeOff: "TimeOff",
  // TeamTime: "TeamTime",
  // Pay: "NotImplemented",
  Tasks: "Tasks",
  Profile: "Profile",
  Requests: "Requests",
  // Benefits: "NotImplemented",
  // Career: "NotImplemented",
  // BrowseJobs: "NotImplemented",
  NotImplemented: "NotImplemented"
  // UserManagement: "UserManagement"
  // Roles: "Roles",
  // RolesAssociation: "RolesAssociation"
});

/**
 * Employee Access entities
 * @type {Readonly<{Tasks: string, TimeOff: string, Dashboard: string, Time: string, Requests: string, Profile: string}>}
 */
const entities = Object.freeze({
  Dashboard: "Dashboard",
  Time: "My Time",
  TimeOff: "My Time Off",
  // TeamTime: "Team Time",
  // Pay: "My Pay",
  Tasks: "My Tasks",
  Profile: "My Profile",
  Requests: "My Requests"
  // Benefits: "My Benefits",
  // Career: "My Career",
  // BrowseJobs: "Browse Jobs",
  // UserManagement: "User Management"
  // Roles: "Roles",
  // RolesAssociation: "Roles Association"
});

/**
 * Employee Access page titles
 * @type {Readonly<{Tasks: string, TimeOff: string, Dashboard: string, Time: string, Requests: string, TaskDetail: string, Profile: string}>}
 */
const pageTitles = Object.freeze({
  Dashboard: "Dashboard",
  Time: "Time",
  TimeOff: "Time Off",
  Tasks: "Tasks",
  TaskDetail: "Task Detail",
  Profile: "Profile",
  Requests: "Requests"
});

/**
 * Employee Access modules
 * @type {({route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string}|{route: string, icon: string, name: string, title: string, entity: string})[]}
 */
const modules = Object.freeze([
  {
    title: titles.Dashboard,
    icon: icons.Dashboard,
    name: names.Dashboard,
    route: routes.Dashboard,
    entity: entities.Dashboard
  },
  {
    title: titles.Time,
    icon: icons.Time,
    name: names.Time,
    route: routes.Time,
    entity: entities.Time
  },
  {
    title: titles.TimeOff,
    icon: icons.TimeOff,
    name: names.TimeOff,
    route: routes.TimeOff,
    entity: entities.TimeOff
  },
  // {
  //   title: titles.TeamTime,
  //   icon: icons.TeamTime,
  //   name: names.TeamTime,
  //   route: routes.TeamTime,
  //   entity: entities.TeamTime
  // },
  // {
  //   title: titles.Pay,
  //   icon: icons.Pay,
  //   name: names.Pay,
  //   route: routes.Pay,
  //   entity: entities.Pay
  // },
  {
    title: titles.Tasks,
    icon: icons.Tasks,
    name: names.Tasks,
    route: routes.Tasks,
    entity: entities.Tasks
  },
  {
    title: titles.Profile,
    icon: icons.Profile,
    name: names.Profile,
    route: routes.Profile,
    entity: entities.Profile
  },
  {
    title: titles.Requests,
    icon: icons.Requests,
    name: names.Requests,
    route: routes.Requests,
    entity: entities.Requests
  }
  // {
  //   title: titles.Benefits,
  //   icon: icons.Benefits,
  //   name: names.Benefits,
  //   route: routes.Benefits,
  //   entity: entities.Benefits
  // },
  // {
  //   title: titles.Career,
  //   icon: icons.Career,
  //   name: names.Career,
  //   route: routes.Career,
  //   entity: entities.Career
  // },
  // {
  //   title: titles.BrowseJobs,
  //   icon: icons.BrowseJobs,
  //   name: names.BrowseJobs,
  //   route: routes.BrowseJobs,
  //   entity: entities.BrowseJobs
  // },
  // {
  //   title: titles.UserManagement,
  //   icon: icons.UserManagement,
  //   name: names.UserManagement,
  //   route: routes.UserManagement,
  //   entity: entities.UserManagement
  // }
  // {
  //   title: titles.Roles,
  //   icon: icons.Roles,
  //   name: names.Roles,
  //   route: routes.Roles,
  //   entity: entities.Roles
  // },
  // {
  //   title: titles.RolesAssociation,
  //   icon: icons.RolesAssociation,
  //   name: names.RolesAssociation,
  //   route: routes.RolesAssociation,
  //   entity: entities.RolesAssociation
  // }
]);

/**
 * Employee Access dashboard
 * @type {Readonly<{route: string, icon: string, name: string, title: string, entity: string}>}
 */
const dashboard = Object.freeze({
  title: "Dashboard",
  icon: appIcons.EmployeeAccess,
  name: "Dashboard",
  route: "Dashboard",
  entity: "Dashboard"
});

export {
  modules,
  routes,
  titles,
  names,
  icons,
  entities,
  dashboard,
  pageTitles
};
